import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Option } from '@/components/inputs/AutocompleteInput';
import { GlobalButton } from '@/components';
import { 
  FactCheck as RendirIcon,
  ShoppingCartCheckout as OrdersIcon, 
  Person as PersonIcon,
} from '@mui/icons-material';
import SummaryItem from './ScannerActions/SummaryItem';
import ReturnStatusBadge from './ScannerActions/ReturnStatusBadge';

interface ScannerActionsProps {
  driver: Option | null;
  count: number;
  onReturn: () => void;
  disabled: boolean;
}

const ScannerActions = ({
  driver,
  count,
  onReturn,
  disabled,
}: ScannerActionsProps) => {
  const status = {
    ready: count > 0 && !!driver,
    text: count > 0 && !!driver ? 'Listo para rendir' : 'Pendiente de escaneo',
  };

  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-6'>
      <div className='flex flex-col md:flex-row items-center justify-between gap-8'>
        <div className='flex items-center gap-10'>
          <SummaryItem
            label='Conductor Seleccionado Para Rendir'
            icon={<PersonIcon sx={{ fontSize: 18 }} />}
            value={
              driver?.label || (
                <span className='text-gray-300 italic'>No seleccionado</span>
              )
            }
          />

          <div className='h-10 w-px bg-gray-100' />

          <SummaryItem
            label='Total de Pedidos Que Devuelve'
            icon={<OrdersIcon sx={{ fontSize: 18 }} />}
            value={`${count} Pedido${count !== 1 ? 's' : ''}`}
          />
        </div>

        <div className='flex items-center gap-6'>
          <ReturnStatusBadge ready={status.ready} text={status.text} />

          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={onReturn}
            disabled={disabled}
          >
            <RendirIcon sx={{ mr: 1 }} />
            RENDIR PEDIDOS
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default ScannerActions;
